












import { Vue, Component } from 'vue-property-decorator';
import { getBaseInfo } from './api';
import { isWeiXin } from '@/common/ts/common';
import BottomTabBar from '@/components/BottomTabbar.vue';
@Component({
  components: {
    BottomTabBar,
  },
})
export default class ViewHolder extends Vue {
  tabs = [
    { tabName: '评选规则', tabPath: '/20210323JJRWPX/rules' },
    { tabName: '相关新闻', tabPath: '/20210323JJRWPX/news' },
    // { tabName: '报名通道', tabPath: '/20210323JJRWPX/apply' },
    { tabName: '参评人风采', tabPath: '/20210323JJRWPX/home' },
  ];
  themeColor = { activeBgColor: '#b41d2b', inactiveBgColor: '#FFFFFF' };
  baseInfo: any = {};
  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    console.log('base info is:', ret);
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2020十大重庆经济年度人物评选',
      url: location.href,
      subtitle: '2020十大重庆经济年度人物评选',
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2020十大重庆经济年度人物评选',
        subtitle: '2020十大重庆经济年度人物评选',
        image: cover,
      });
    }
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
